<template src="./PatientData.html" />

<script>
import { useStore } from "@/store/store.js"
import moment from "moment";
import PatientAttendance from "../PatientAttendance/PatientAttendance.vue";
import History from "../History/History.vue";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
import mixins from "@/Mixins.js";

export default {
  mixins: [mixins],
  name: "patient-data",
  components: {
    PatientAttendance,
    History,
    WholeMultiselect
  },
  props: ["medicalRecordId"],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      showTabs: true,
      genderOptions: [
        { text: "Feminino", value: "FEMALE" },
        { text: "Masculino", value: "MALE" }
      ],
      page: 0,
      genderPatient: "",
      maritalStatus: [],
      maritalStatusPatient: null,
      educationalAttainmentsPatient: null,
      educationalAttainments: [],
      address: {
        id: "",
        zipcode: "",
        city: "",
        complement: "",
        neighborhood: "",
        state: "",
        street: "",
        number: ""
      },
      firstAppointmentDateUsFormat: null,
      answer: [
        { text: "Sim", value: true },
        { text: "Não", value: false }
      ],
      hospitalizations: [],
      previousDiseases: [],
      surgeries: [],
      idPatient: 0,
      continuousMedicationUse: [],
      cancerHistory: [],
      blockFields: true,
      dataEntered: [],
      smoking: null,
      showPatientData: true,
      showPatientAttendance: false,
      showPatientHistoric: false,
      height: null,
      weight: null,
      arterialPressure: null,
      abdominalCircumference: null,
      glycemia: null,
      alcoholism: null,
      drugs: null,
      quantitySmoking: null,
      physicalActivity: null,
      someoneSystemicArterialHypertension: null,
      someoneAcuteMyocardialInfarction: null,
      someoneDementiaSyndrome: null,
      someoneDiabetesMelitus: null,
      someoneStroke: null,
      someoneDepression: null,
      canEdit: null,
      bearerDefault: "",
      nonEditable: false,
    };
  },
  setup () {
    const store = useStore()

    return {
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  created() {
    const vm = this;
    vm.bearerDefault = vm.$session.get("bearerDefault");
    vm.addHospitalization();
    vm.addPreviusDiase();
    vm.addSurgery();
    vm.addCancerHistory();
    vm.addContinuousMedicationUse();
    vm.getRegistrationData();
    vm.getMaritalStatus();
    vm.getEducationalAttaiments();
    vm.getHealthData();
    if (vm.$props.isNew === true) {
      vm.blockFields = true;
    }
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  methods: {
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width < 420) {
        vm.showTabs = false;
      } else {
        vm.showTabs = true;
      }
    },
    goToPatientData() {
      const vm = this;
      vm.page = 0;
    },
    goToPatientHistoric() {
      const vm = this;
      vm.page = 2;
    },
    goToPatientAttendance() {
      const vm = this;
      vm.page = 1;
    },
    goBackPage() {
      const vm = this;
      vm.$session.set("bearer", vm.bearerDefault);
      window.history.back();
    },
    showPagePatientData() {
      const vm = this;
      vm.showPatientAttendance = false;
      vm.showPatientData = true;
      vm.showPatientHistoric = false;
      vm.page = 0;
      window.scrollTo(50, 50);
    },
    showPagePatientAttendance() {
      const vm = this;
      vm.showPatientAttendance = true;
      vm.showPatientData = false;
      vm.showPatientHistoric = false;
      vm.page = 1;
      window.scrollTo(50, 50);
    },
    addHospitalization() {
      const vm = this;
      vm.hospitalizations.push("");
    },
    removeHospitalization(index) {
      const vm = this;
      vm.hospitalizations.splice(index, 1);
    },
    addPreviusDiase() {
      const vm = this;
      vm.previousDiseases.push("");
    },
    removePreviusDiase(index) {
      const vm = this;
      vm.previousDiseases.splice(index, 1);
    },
    addSurgery() {
      const vm = this;
      vm.surgeries.push("");
    },
    removeSurgery(index) {
      const vm = this;
      vm.surgeries.splice(index, 1);
    },
    addContinuousMedicationUse() {
      const vm = this;
      vm.continuousMedicationUse.push("");
    },
    removeContinuousMedicationUse(index) {
      const vm = this;
      vm.continuousMedicationUse.splice(index, 1);
    },
    addCancerHistory() {
      const vm = this;
      vm.cancerHistory.push("");
    },
    removeCancerHistory(index) {
      const vm = this;
      vm.cancerHistory.splice(index, 1);
    },
    getHealthData() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            "/health-data",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.fillPersonalbackground(response.data);
            vm.fillFamilyHistory(response.data);
            vm.smoking = vm.answer.find(a => {
              return a.value === response.data.smoking;
            });
            vm.height = response.data.height;
            vm.weight = response.data.weight;
            vm.arterialPressure = response.data.arterialPressure;
            vm.abdominalCircumference = response.data.abdominalCircumference;
            vm.glycemia = response.data.glycemia;
            vm.alcoholism = vm.answer.find(a => {
              return a.value === response.data.alcoholism;
            });
            vm.drugs = vm.answer.find(a => {
              return a.value === response.data.drugs;
            });
            vm.physicalActivity = vm.answer.find(a => {
              return a.value === response.data.physicalActivity;
            });
            vm.quantitySmoking = response.data.quantitySmoking;
            vm.someoneSystemicArterialHypertension = vm.answer.find(a => {
              return a.value === response.data.has;
            });
            vm.someoneAcuteMyocardialInfarction = vm.answer.find(a => {
              return a.value === response.data.iam;
            });
            vm.someoneDementiaSyndrome = vm.answer.find(a => {
              return a.value === response.data.sd;
            });
            vm.someoneDiabetesMelitus = vm.answer.find(a => {
              return a.value === response.data.dm;
            });
            vm.someoneStroke = vm.answer.find(a => {
              return a.value === response.data.avc;
            });
            vm.someoneDepression = vm.answer.find(a => {
              return a.value === response.data.dp;
            });
            vm.canEdit = response.data.canEdit;
          }
        });
    },
    fillPersonalbackground(response) {
      const vm = this;
      var index = 0;

      if (response.surgeries.length > 1) {
        for (index = 0; index < response.surgeries.length; index++) {
          vm.surgeries[index] = response.surgeries[index];
        }
      }

      if (response.hospitalizations.length > 1) {
        for (index = 0; index < response.hospitalizations.length; index++) {
          vm.hospitalizations[index] = response.hospitalizations[index];
        }
      }

      if (response.previousDiseases.length > 1) {
        for (index = 0; index < response.previousDiseases.length; index++) {
          vm.previousDiseases[index] = response.previousDiseases[index];
        }
      }

      if (response.continuousMedications.length > 1) {
        for (
          index = 0;
          index < response.continuousMedications.length;
          index++
        ) {
          vm.continuousMedicationUse[index] =
            response.continuousMedications[index];
        }
      }
    },
    fillFamilyHistory(response) {
      const vm = this;
      var index = 0;
      if (response.cancer.length > 1) {
        for (index = 0; index < response.cancer.length; index++) {
          vm.cancerHistory[index] = response.cancer[index];
        }
      }
      vm.cancerHistory.filter(c => c);
    },
    getRegistrationData() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            "/registration-data",
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.dataEntered = response.data;
            vm.idPatient = vm.dataEntered.patientId;
            vm.genderPatient = vm.genderOptions.find(g => {
              return g.value === vm.dataEntered.gender;
            });
            vm.testNullUndefinedEmpty(vm.dataEntered.maritalStatus)
              ? (vm.maritalStatusPatient = { description: "", id: "" })
              : vm.dataEntered.maritalStatus;
            vm.testNullUndefinedEmpty(vm.dataEntered.educationalAttainment)
              ? (vm.educationalAttainmentsPatient = { description: "", id: "" })
              : vm.dataEntered.educationalAttainment;

            vm.firstAppointmentDateUsFormat = vm.dateFormatted(
              vm.dataEntered.firstAppointment
            );
            vm.address = vm.dataEntered.address;
          }
        });
    },
    dateFormatted(date) {
      var day = date.split("/")[0];
      var month = date.split("/")[1];
      var year = date.split("/")[2];

      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    getMaritalStatus() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "patient/marital-status", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.maritalStatus = response.data;
          }
        });
    },
    getEducationalAttaiments() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "/patient/educational-attainments", {
          headers: { Authorization: vm.$session.get("bearer") }
        })
        .then(function(response) {
          if (response.status === 200) {
            vm.educationalAttainments = response.data;
          }
        });
    },
    async getAdressData() {
      const response = await this.getAddressByZipcode(this.address.zipcode)

      if (response && response.address) {
        this.address = response.address
      }
    },
    saveHealthData() {
      const vm = this;
      var cleanArrayCancerHistory = vm.cancerHistory.filter(c => c);
      var cleanArrayHospitalizations = vm.hospitalizations.filter(h => h);
      var cleanArraySurgeries = vm.surgeries.filter(s => s);
      var cleanArrayPreviousDiases = vm.previousDiseases.filter(p => p);
      var cleanArrayContinuousMedicationUse = vm.continuousMedicationUse.filter(
        cm => cm
      );

      var healthData = {
        abdominalCircumference: vm.abdominalCircumference,
        alcoholism: vm.alcoholism.value,
        arterialPressure: vm.arterialPressure.value,
        avc: vm.someoneStroke.value,
        bloodTransfusions: [],
        canEdit: vm.dataEntered.canEdit,
        cancer: cleanArrayCancerHistory,
        continuousMedications: cleanArrayContinuousMedicationUse,
        dm: vm.someoneDiabetesMelitus.value,
        dp: vm.someoneDepression.value,
        drugs: vm.drug.values,
        glycemia: vm.glycemia,
        has: vm.someoneSystemicArterialHypertension.value,
        height: vm.height,
        hospitalizations: cleanArrayHospitalizations,
        iam: vm.someoneAcuteMyocardialInfarction.value,
        patientId: vm.dataEntered.patientId,
        patientName: vm.dataEntered.patientName,
        physicalActivity: vm.physicalActivity.value,
        previousDiseases: cleanArrayPreviousDiases,
        quantitySmoking: vm.quantitySmoking,
        sd: vm.someoneDementiaSyndrome.value,
        smoking: vm.smoking.value,
        surgeries: cleanArraySurgeries,
        weight: vm.weight
      };
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            "/health-data",
          healthData,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.$swal({
              title: "Sucesso!",
              text: "Dados do paciente salvos com sucesso",
              icon: "success"
            }).then(function() {
              vm.showPatientData = false;
            });
          }
        });
    },
    saveRegistrationData() {
      const vm = this;
      var firstAppointmentFormatToBr = vm.testNullUndefinedEmpty(vm.firstAppointmentDateUsFormat) ? 
        null :
        moment(String(vm.firstAppointmentDateUsFormat)).format("DD/MM/YYYY");
      var registrationtData = {
        acceptJanssenProgram: vm.dataEntered.acceptJanssenProgram,
        adress: vm.address,
        age: vm.dataEntered.age,
        canEdit: true,
        cnpj: vm.dataEntered.cnpj,
        companyName: vm.dataEntered.companyName,
        contactCellPhone: vm.dataEntered.contactCellPhone,
        contactEmail: vm.dataEntered.contactEmail,
        contactWhatsApp: vm.dataEntered.contactWhatsApp,
        cpf: vm.dataEntered.cpf,
        dateBirth: vm.dataEntered.dateBirth,
        educationalAttainment: vm.educationalAttainmentsPatient,
        email: vm.dataEntered.email,
        firstAppointment: firstAppointmentFormatToBr,
        gender: vm.genderPatient.value,
        indication: vm.dataEntered.indication,
        maritalStatus: vm.maritalStatusPatient,
        meansProfissionalContact: vm.dataEntered.meansProfissionalContact,
        naturalness: vm.dataEntered.naturalness,
        notifyByEmail: vm.dataEntered.notifyByEmail,
        notifyByFlyer: vm.dataEntered.notifyByFlyer,
        notifyByPhone: vm.dataEntered.notifyByPhone,
        notifyBySMS: vm.dataEntered.notifyBySMS,
        occupation: vm.dataEntered.occupation,
        patientId: vm.dataEntered.patientId,
        patientName: vm.dataEntered.patientName,
        phone: vm.dataEntered.phone,
        preferenceHistoric: vm.dataEntered.preferenceHistoric,
        religion: vm.dataEntered.religion,
        resideWith: vm.dataEntered.resideWith
      };

      if (
        JSON.stringify(registrationtData.maritalStatus) ===
        JSON.stringify({ description: "", id: "" })
      ) {
        registrationtData.maritalStatus = null;
      }
      if (
        JSON.stringify(registrationtData.educationalAttainment) ===
        JSON.stringify({ description: "", id: "" })
      ) {
        registrationtData.educationalAttainment = null;
      }
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "medical-records/" +
            vm.$route.params.id +
            "/registration-data",
          registrationtData,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.$swal({
              title: "Sucesso!",
              text: "Dados do paciente salvos com sucesso",
              icon: "success"
            }).then(function() {
              vm.showPagePatientAttendance();
            });
          }
        });
    },
  }
};
</script>
<style lang="scss" src="./PatientData.scss"></style>
